import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDealer, fetchZipCode } from './service';

export const fetchZipCodeAsync = createAsyncThunk(
  'inventoryNearYou/fetchZipCodeAsync',
  async () => {
    const response = await fetchZipCode();
    return response.data;
  },
);

export const fetchDealerAsync = createAsyncThunk(
  'inventoryNearYou/fetchDealerAsync',
  async ({ zip, ModelID }) => {
    try {
      const response = await fetchDealer({ zip, ModelID });
      return response.data;
    } catch (error) {
      return null;
    }
  },
);
